import { Record } from 'immutable';

const UserRecord = Record({
  username: null,
  email: null,
  firstName: null,
  lastName: null,
  expiration: null,
  allChains: null,
  allBrands: null,
  allProperties: null,
  allArcIatas: null,
  customerInfo: null,
  type: null
});

export class User extends UserRecord {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  expiration: Date;
  allChains: string[];
  allBrands: string[];
  allProperties: string[];
  allArcIatas: string[];
  customerInfo: string[];
  type: UserType;
}

export enum UserType {
  HOTEL = <any>'HOTEL',
  AGENCY = <any>'AGENCY',
  SUPPORT = <any>'SUPPORT'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/models/User.ts